import type { ReactElement, ReactNode } from 'react'

import { Layout, Text } from '@loadsmart/miranda-react'

type ItemProps = {
  label: string
  value?: ReactNode
  icon?: ReactElement
}

export function Item({ label, value, icon }: ItemProps) {
  return (
    <Layout.Stack gap="spacing-2">
      <Text variant="body-sm" color="color-text-tertiary">
        {label}
      </Text>
      <Layout.Group gap="spacing-1">
        {icon}
        <Text variant="body-md">{value || '-'}</Text>
      </Layout.Group>
    </Layout.Stack>
  )
}
